import { ReportedFindingData } from '@acp/shared';
import { ListItem, UnorderedList } from '@chakra-ui/react';
import { formatDistanceToNow, parseISO } from 'date-fns';

export function ReportedFindingItemList({
    reportedFindings,
}: {
    reportedFindings: ReportedFindingData[];
}) {
    return (
        <UnorderedList color="muted.700" fontSize="small">
            {reportedFindings.map((reportedFinding, idx: number) => (
                // eslint-disable-next-line react/no-array-index-key
                <ListItem key={`problem-${idx}`}>
                    {reportedFinding.originalProblemItem.title}
                    {` - notified ${formatDistanceToNow(
                        parseISO(reportedFinding.problemRegister.originalBookingDate),
                        {
                            addSuffix: true,
                        }
                    )}`}
                </ListItem>
            ))}
        </UnorderedList>
    );
}
